export default "__VITE_ASSET__a7b016d6__"